import jwtDecode from "jwt-decode";

export const getToken = () => {
    const storedToken = localStorage.getItem("token");
  return storedToken && storedToken !== "undefined" ? storedToken : null;
};
 
export const setToken = (token) => {
  if (token) {
    localStorage.setItem("token", token);
  } else {
    localStorage.removeItem("token");
  }
};

export const getDecodedToken = () => {
  const token = getToken();
  try {
    return token ? jwtDecode(token) : null;
  } catch (err) {
    console.error("Invalid token", err);
    return null;
  }
};